import { __awaiter } from "tslib";
import { CurrentAppPermissionsRequestDialogOriginator, DevicePermissionsRequestDialogOriginator, } from '@office-start/device-permission-types';
import { getAppPermissionsDialogEventHandler } from './getAppPermissionsDialogEventHandler';
import { getConsentNovaEventHandler } from './getConsentNovaEventHandler';
export const getAppHostNovaEventHandler = (props) => {
    return {
        bubble({ event }) {
            return __awaiter(this, void 0, void 0, function* () {
                if (event.originator === DevicePermissionsRequestDialogOriginator) {
                    getConsentNovaEventHandler(event, props.hideRequestDialog);
                }
                if (event.originator ===
                    CurrentAppPermissionsRequestDialogOriginator) {
                    getAppPermissionsDialogEventHandler(event, props.currentAppPermissions);
                }
                return Promise.resolve();
            });
        },
    };
};
//# sourceMappingURL=getAppHostNovaEventHandler.js.map